import React from 'react';

import { UseModalResult } from '../../hooks/modalHooks/modalHooks';
import { UrlType } from '../../types/apiEnums';
import {
  ColorPresentational,
  ImagePresentational,
  LinkPresentational,
} from '../../types/common';
import { Button, ButtonFit, ButtonIntent } from '../Button/Button';
import { Link, LinkType } from '../Link/Link';
import { ProductDetailsBrandsBlock } from '../ProductDetailsBrandsBlock/ProductDetailsBrandsBlock';
import {
  ProductDetailsPageCardPreview,
} from '../ProductDetailsPageCardPreview/ProductDetailsPageCardPreview';
import { ProductDetailsUsps } from '../ProductDetailsUsps/ProductDetailsUsps';
import { Title } from '../Title/Title';
import styles from './BusinessGiftCardBlock.module.css';

export type Props = {
  backgroundColor: ColorPresentational;
  brands: ImagePresentational[];
  brandsModalProps: UseModalResult;
  button: LinkPresentational | null;
  image: ImagePresentational;
  isDesktop: boolean;
  isEmblaSliderOn: boolean;
  isMobile: boolean;
  showHand: boolean;
  title: string;
  usps: string[];
};

export const BusinessGiftCardBlock = React.memo((props: Props) => {
  const {
    backgroundColor,
    brands,
    button,
    image,
    showHand,
    title,
    usps,
    isDesktop,
    isMobile,
    brandsModalProps,
    isEmblaSliderOn,
  } = props;

  return (
    <div className={styles.businessGiftCardBlock}>
      <ProductDetailsPageCardPreview
        backgroundColor={backgroundColor}
        image={image}
        imagePreviewContainerClassName={styles.imagePreviewContainer}
        productImageContainerClassName={styles.productImageContainer}
        showHandMain={showHand}
        isDesktop={isDesktop}
        isEmblaSliderOn={isEmblaSliderOn}
      />

      <div className={styles.productOrderContainer}>
        <div className={styles.productOrderWrapper}>
          <Title title={title} className={styles.title} />

          <ProductDetailsUsps usps={usps} className={styles.productDetailsUsps} />

          <ProductDetailsBrandsBlock
            brands={brands}
            className={styles.productDetailsBrandsBlock}
            isMobile={isMobile}
            brandsModalProps={brandsModalProps}
          />

          {button && <Link
            type={button.url.type === UrlType.ABSOLUTE ? LinkType.ExternalHref : LinkType.Href}
            to={button.url.href}
            withoutHoverStyles
            isBlock={true}
          >
            <Button
              intent={ButtonIntent.primary}
              fit={isDesktop ? ButtonFit.Inline : ButtonFit.Fill}
              disabled={false}
              className={styles.redirectButton}
              isLink
            >
              {button.title}
            </Button>
          </Link>}
        </div>
      </div>
    </div>
  );
});

BusinessGiftCardBlock.displayName = 'BusinessGiftCardBlock';
